<template>
    <div :class="['content-container', 'ipad', {'desktop': !this.isIpad}]">

        <NavBar title="Select product"></NavBar> 

        <!-- Content -->
        <div class="container">
            <div class="grid-container" v-if="!noProducts">
                <div v-for="product in allowedProducts" 
                     :key="product.nid[0].value"
                     class="flex-50 product-flex-box"
                >
                    <router-link :to="'/timeline/product/'+ product.title[0].value +''"
                                 @click.native="trackEvent"
                                 class="grid-item product"
                                 data-category="Product Navigation"
                                 data-action="button_press"
                                 :data-event="product.title[0].value"
                    >
                        
                        <template v-if="product.field_molecule_video.length > 0">
                            <template v-if="moleculeIsVideo(product.field_molecule_video[0].url)">
                                <!--<video autoplay loop muted preload="auto" v-if="product.field_molecule_video.length > 0">
                                    <source type="video/mp4" :src="setImagePath(product.field_molecule_video[0].url)">
                                </video>-->

                                <div class="video-wrapper">
                                    <video autoplay loop muted preload="auto" v-if="product.field_molecule_video.length > 0">
                                        <source type="video/mp4" :src="product.field_molecule_video[0].url">
                                    </video>
                                </div>
                            </template>
                            <img v-else :src="product.field_molecule_video[0].url">  
                        </template>
                        <div class="d-flex justify-content-center">
                            <h2 class="title" v-html="product.title[0].value"></h2>
                            <div v-if="product.field_black_triangle_for_product[0] && product.field_black_triangle_for_product[0].value" 
                                 v-html="product.field_black_triangle_for_product[0].value"
                                 class="ml-1"
                            ></div>
                        </div>
                        <h3 class="subtitle" v-html="product.field_product_description[0].value"></h3>
                    </router-link>
                </div>
            </div>
            <div class="alert alert-danger" role="alert" v-else>
                There are no available products. 
             </div>
        </div>
       
        <!-- Background Image -->
        <div class="img-bg">
            <img src="img/backgrounds/timeline.png" class="bottom-center">
        </div>
    </div>
</template>

<script>
    import NavBar from './components/NavBar.vue'; 

    export default {
        name: 'SelectProduct',
        components: {
            NavBar 
        },
        data: function() {
            return {
                noProducts: false 
            }
        },
        computed: {
            products() { 
                console.log("All products",this.$store.getters.allProducts);
                return this.$store.getters.allProducts
            },
            productNames() { return this.$store.getters.getProductNames },
            allowedProducts() {return this.productsToShow() }
        },
        beforeRouteLeave (to, from, next) {
            if (to.params.filtervalue) {
              let page = 'Product Page - ' + to.params.filtervalue;
              this.$root.track("callback://screenname_" + page);
            }
            next();
        },
        methods: {
            productsToShow: function() {
                const prods = this.$store.getters.getAllowedProducts;
                this.noProducts = prods.length <= 0;
                return prods;
            },
            htmlEncodePath: function(path) {
                return encodeURI(path); 
            },
            setImagePath: function(path){
                let p = path; 
                //p = this.htmlEncodePath(p);
                return p.replace('public/', '');
            },
            moleculeIsVideo(url) {
                let urlString = url.toLowerCase(); 
                let fileExtension = urlString.substr(-3);
                
                if(fileExtension == 'mp4') {
                    return true;
                }

                return false;
            },
            trackEvent: function(event) {
                this.analytics.trackEvent(this.$router.currentRoute.path, 'navigation', event.target);
            }
        }
    }
</script> 

<style scoped >
    video {
        max-height: 200px; 
        height: 100%;
    }

    .container {
        padding: 40px 0px 110px;
    }

    .grid-container {
        justify-content: space-around;
        width: 100%;
        margin: 0 auto;
    }

    .grid-item.product {
        justify-content: center;
        width: 400px;
        min-height: 320px;
    }

    .grid-item:last-of-type::after {
        flex: none;
    }

    .flex-50 {
        display: flex;
        flex: 0 0 50%;
    }
    .flex-50:nth-child(odd) {
       
    }
    .flex-50:nth-child(even) {
        justify-content: flex-start;
    }

    @media (min-height: 1050px) {
        .grid-item.product {
            width: 500px;
            min-height: 375px;
        }

        .subtitle {
            height: 2.5em;
        }
    }

    @media (min-width: 1024px) {
        
        .grid-item.product {
            max-width: 500px;
        }
    }

    @media (min-width: 1400px) {
        
        .grid-item.product {
            max-width: 500px;
        }
    }

    @media (max-height: 800px) {
        .grid-item.product {
            width: 350px;
            min-height: 290px;
            max-height: 290px;
        }
    }

    @media (max-height: 750px) {
        .grid-item.product {
            width: 350px;
            min-height: 270px;
            max-height: 270px;
        }
        .grid-item.product video {
            max-height: 175px;
        }
    }

</style> 